import type { WidgetDisplay } from '../schemas'
import { STYLE_PRESETS, applyPreset } from './stylePresets'

type StylePresetPickerProps = {
  value?: string
  onSelect: (patch: { display: Partial<WidgetDisplay> }) => void
}

/**
 * Bande de pastilles de preset "rapport" : une ligne de 7 chips, sans libellé texte visible
 * (le nom du preset n'apporte pas plus d'info que sa couleur pour un choix rapide) —
 * accessible via `title`/`aria-label`. Décision validée sur maquette, 2026-08-06.
 */
export default function StylePresetPicker({ value, onSelect }: StylePresetPickerProps) {
  return (
    <div className="flex gap-1.5" role="group" aria-label="Preset de style">
      {STYLE_PRESETS.map((preset) => {
        const active = value === preset.key
        return (
          <button
            key={preset.key}
            type="button"
            title={preset.label}
            aria-label={preset.label}
            aria-pressed={active}
            onClick={() => onSelect(applyPreset(preset.key))}
            className="h-7 w-7 shrink-0 rounded-md transition-shadow"
            style={{
              backgroundColor: preset.bg ?? '#ffffff',
              border: `1px solid ${preset.border_color ?? '#E2E4ED'}`,
              boxShadow: active ? '0 0 0 2px #ffffff, 0 0 0 3.5px #6366F1' : 'none',
            }}
          />
        )
      })}
    </div>
  )
}
